import { DEFAULT_FONT } from 'commons/styles/font';
import styled, { css } from 'styled-components';

interface StepProps {
  isCurrentStep?: boolean;
  hasClick?: boolean;
}

export const Container = styled.div<{ justOneStep: boolean }>`
  display: flex;
  width: 100%;
  gap: 20px;
  justify-content: space-between;
  position: relative;
  font-family: ${DEFAULT_FONT};

  &:after {
    content: '';
    position: absolute;
    left: 50px;
    top: 17px;
    z-index: 0;
    width: calc(100% - 80px);
    height: 1px;
    background-color: #e3e3e3;
  }
  &:last-child {
    &:after {
      content: '';
      height: 10px;
    }
  }
  ${({ justOneStep }) =>
    justOneStep &&
    css`
      justify-content: center;
      &:after {
        display: none;
      }
    `}
`;
export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StepOrder = styled.div<StepProps>`
  display: flex;
  width: 34px;
  height: 34px;
  background: ${({ isCurrentStep, theme }) => (isCurrentStep ? theme.palette.primary.main : '#E3E3E3')};
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  color: ${({ isCurrentStep }) => (isCurrentStep ? '#ffffff' : '#000000')};
  font-size: 16px;
  z-index: 3;
  position: relative;

  ${({ hasClick }) =>
    hasClick &&
    css`
      cursor: pointer;
    `}
`;

export const StepText = styled.div<StepProps>`
  text-align: center;
  margin-top: 15px;
  color: ${({ isCurrentStep, theme }) => (isCurrentStep ? theme.palette.primary.main : '#999999')};
  max-width: 100px;
  font-size: 14px;
`;
